import React from 'react';
import load from './load.svg';
function Load(props){
	return(
		<div className={props.display?'load show':'load'}>
			<img src={load} alt='load'/>
		</div>
	);
}
function DeleteItem(props){
	return(
		<div className={props.display?'overlay show':'overlay'}>
			<div className="alert text-center">
				<h3>¿Desea eliminar este elemento?</h3>
				{props.name !== '0' ? <h4>{props.name}</h4> : '' }<br/>
				<div className="btn btn-green" onClick={props.deleteItem}>Aceptar</div>
				<div className="btn btn-red" onClick={props.closeModalDelete}>Cancelar</div>
			</div>
		</div>
	);
}
function Confirm(props){
	return(
		<div className={props.display?'overlay confirm show':'overlay confirm'}>
			<div className="alert text-center">
				<h3>¿Desea guardar cambios?</h3>
				<div style={{marginTop:'6px'}}>
					<div className="btn btn-green" onClick={props.onSubmit}>Aceptar</div>
					<div className="btn btn-red" onClick={props.discard}>Descartar</div>
				</div>
			</div>
		</div>
	);
}
const Confirmar = (props) => {
	return(
		<div className={props.fadeIn?'overlay confirm show':'overlay confirm'}>
			<div className="alert text-center">
				<h3>{props.message}</h3>
				<div style={{marginTop:'12px'}}>
					<div className="btn btn-green" onClick={props.saveCaja}>Aceptar</div>
					<div className="btn btn-red" onClick={props.confirm}>Descartar</div>
				</div>
			</div>
		</div>
	);
}
// 1623940024
function ModalDevolucion({display,handler,folio,devolucion,close}){
	return (
		<div className={display?'overlay confirm show':'overlay confirm'}>
			<div className="alert text-center devolucion">
				<h3>Ingrese el folio de la venta</h3>
				<input name="folioVenta" onChange={handler} value={folio||''}/><br/>
				<div className="btn btn-green" onClick={devolucion}>Buscar</div>
				<div className="btn btn-red" onClick={close}>Cerrar</div>
			</div>
		</div>
	)
}


function Modal(props){
	const { title, message, close, show } = props;
	return(
		<div className={show ? 'overlay confirm show':'overlay confirm'}>
			<div className="alert text-center">
				<h3>{title}</h3>
				<p>{message}</p>
				<div className="btn btn-green" onClick={()=>close()}>Cerrar</div>
			</div>
		</div>
	);
}
function Success(props){
	let title='';
	if( props.action === 'success'){
		title = <h3>Operación realizada con éxito</h3>
	}else{
		title = <div><h3>¡Advertencia!</h3><p>{props.message}</p></div>
	}
	return(
		<div className={props.display?'overlay confirm show':'overlay confirm'}>
			<div className="alert text-center">
				{title}
				<div className="btn btn-green" onClick={()=>props.windowCloseUpdate(props.action)}>Aceptar</div>
			</div>
		</div>
	);
}
function Thead(props){
	let th = [];
	props.columns.forEach((item,i)=>{
		th.push(<th className="th" key={i}>{item}</th>);
	});
	return(
		<thead>
			<tr>
				{th}
			</tr>
		</thead>
	);
}

function SearchBar({searchHandler, openModal, text}){
	return <>
		<div className="xs-12 sm-8 md-8 lg-8">
			<div className="content-search">
				<input type="text" placeholder="Buscar…" onChange={searchHandler}/>
				<div className="new">
					<span className="icon-lupa"></span>
				</div>
			</div>
		</div>
      <div className="xs-12 sm-4 md-4 lg-4">
			<div className='btn-medium btn-green' onClick={openModal}>Agregar {text}</div>
		</div>
	</>
}

export {Load, Modal,DeleteItem, Thead, Confirm, Success, ModalDevolucion, SearchBar, Confirmar};

